interface EventData {
    id: string
    name: string
    alias: string
    description: string | null
    category: string | null
    status: EventStatus
    visibility: EventVisibility
    language: string | null
    limit_age: string | null
    schedule: EventSchedule
    max_per_order: number | null
    max_per_user: number | null
    location: EventLocation
    media: EventMedia
    public_selling_page_url: string
    promoter: Promoter
    tickets?: Ticket[]
    unfilteredTickets?: Ticket[]
    filterDate?: Dayjs | null
    seller?: Seller
    coupon?: Coupon
    conditions: string | null
    tracking: {
        google_ads: GoogleAdsTracking | null
        fb_pixel: PixelBasedTracking | null
        tiktok_pixel: PixelBasedTracking | null
        fb_pixel_internal: PixelBasedTracking | null
    }
    insurance_active: boolean
}

interface EventSchedule {
    start: string
    end: string
    timezone: string | null
}

interface EventLocation {
    is_unknown: boolean
    has_secret_location: boolean
    country: string | null
    country_code: string | null
    administration_area_level_1: string | null
    administration_area_level_2: string | null
    address: string | null
    name: string
    zip_code: null
    coordinates: {
        latitude: number
        longitude: number
    }
}

interface EventMedia {
    event_logo: Media | null
    event_banner: Media | null
    venue_plant: Media | null
    color: string | null
}

export enum EventStatus {
    unpublished = 'unpublished',
    published = 'published',
    cancelled = 'cancelled',
    hold = 'on-hold',
}

export enum EventVisibility {
    public = 'public',
    private = 'private',
    unlisted = 'unlisted',
}

export enum EventParticipantInformation {
    mandatory = 'mandatory',
    optional = 'optional',
    unnecessary = 'unnecessary',
}
